import React from 'react'
import { Button, Stack } from '@mui/material'
import ModalConfirmar from './commons/ModalConfirmar'
import colors from '../theme/colors'
import { useTranslation } from "react-i18next"
import FirstPageIcon from "@mui/icons-material/FirstPage"
import { usePerfilEmpresarialActual } from '../hooks/perfilEmpresarial/usePerfilEmpresarialActual'

export const EjesFunctionButtons = ({ volverAMisCuestionarios, setShowPerfilEmpresarial }) => {

    const { t } = useTranslation()
    const { perfilEmpresarial } = usePerfilEmpresarialActual();

    return (
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            marginTop={2}
        >
            <Button
                variant="contained"
                onClick={volverAMisCuestionarios}
                startIcon={<FirstPageIcon icon={FirstPageIcon} sx={{ color: colors.textMain }} />}
                sx={{ width: { xs: '100%', sm: 'auto' } }}
            >
                {t("eje.btnVolver")}
            </Button>
                <Button variant="contained"
                    sx={{ width: { xs: '100%', sm: 'auto' } }}
                    onClick={() => { setShowPerfilEmpresarial(true) }}>
                    {t('crearPerfilEmpresarial.titulo')}
                </Button>
        </Stack>
    )
}
